import React, { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Button } from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";
import { Link } from "react-router";
import { checkApiStatus } from "../../utils_v2";
import { globalFileUploadService } from "../../utils_v2/globalApiServices";

const ImportModal = ({ url,rateType, getResponseBack, onSampleExport,responseKey,importNote,ratioType }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [files, setFiles] = useState([]);
    const onImport = () => {
        var formData = new FormData();
        formData.append('file', files[0]);
        formData.append('type', rateType);
        if(ratioType){
            formData.append('unit_of_measure', ratioType);
        }
        setLoading(true);
        globalFileUploadService(url, formData)
            .then(response => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    enqueueSnackbar("File imported successfully", { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                    setModal(false); 
                    getResponseBack(response?.data?.data,responseKey);
                }else{
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                }
            })
    }
    return (
        <>
            <Button color="primary" variant="text" size='small' onClick={() => setModal(true)}>Import</Button>
            <Dialog
                open={modal}
                onClose={() => setModal(false)}
                maxWidth={'md'}
            >
                <DialogTitle id="scroll-dialog-title">
                    Import
                </DialogTitle>
                <DialogContent style={{ width: "500px" }} dividers={true}>
                    <div >
                        <DropzoneArea
                            acceptedFiles={['.xls, .xlsx,']}
                            filesLimit={1}
                            maxFileSize={104857600}
                            showPreviewsInDropzone={false}
                            useChipsForPreview={true}
                            showPreviews={true}
                            dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop Documents<br /> OR <br /> Click Here<br /> </p>}
                            dropzoneClass="drag-drop-cnt"
                            maxWidth="xl"
                            showAlerts={['info', 'error']}
                            alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                            clearOnUnmount={true}
                            onChange={(files) => setFiles(files)}
                        />
                    </div>
                    <span style={{ fontSize: '11px' }} className='files-upload-limit' > Note : Supported extension only .xls and .xlsx (Only 1 File).</span>
                    <Grid>
                        <Link style={{ color: 'blue', fontSize: '12px', textDecoration: 'underline' }} type="link" onClick={onSampleExport}>Download Sample</Link>
                    </Grid>
                    <Grid>
                        <span style={{ backgroundColor: "#fff1b6", fontSize: '11px' }} >Note: {importNote ? importNote : "Downloaded Sample(export file) can be used to import and create new records."} </span>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button disabled={isLoading} onClick={() => setModal(false)} color='primary' size='small' variant='outlined'>Cancel</Button>
                    <Button disabled={isLoading || files.length === 0} onClick={onImport} color='primary' size='small' variant='contained'>
                        {isLoading ? <CircularProgress size={24} /> : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>

    )
}
export default ImportModal;